/**
 * GlobalShortcuts — headless wiring of the app-wide keyboard shortcuts for the
 * cabinet portal. Mounts once inside the authenticated layout.
 *   - Ctrl/⌘ K → open the command palette
 *   - /         → focus global search (or open palette)
 *   - n         → open the command palette (create/new)
 *   - g d/m/r/… → Gmail-style leader sequences to core modules
 *   - ?         → toggle the keyboard-shortcuts help overlay
 */
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  useKeyboardShortcuts,
  getDefaultShortcuts,
} from '@/hooks/use-keyboard-shortcuts'
import { ShortcutsHelp } from '@/components/ui/shortcuts-help'
import { useCommandPalette } from '@/components/ui/command-palette'

export function GlobalShortcuts() {
  const navigate = useNavigate()
  const { setOpen } = useCommandPalette()

  const shortcuts = useMemo(
    () => getDefaultShortcuts(navigate, (open: boolean) => setOpen(open)),
    [navigate, setOpen],
  )

  useKeyboardShortcuts(shortcuts)

  return <ShortcutsHelp shortcuts={shortcuts} />
}
